(() => {
    'use strict';

    howspace.widgets.onEvent('poll:chart:updated', (widget, notification) => {
        updateChartData(widget, notification?.object?.chart);
        renderCurrentChart(widget);
    });

    const upsertHandler = (widget, notification) => {
        if (!real.events.isFromCurrentUser(notification)) {
            // New UI backend never sends these to anyone else, but just a sanity check.
            return;
        }

        const optionsWrapper = widget.find('.options-wrapper');
        const resultsWrapper = widget.find('.results-wrapper');

        howspace.widgets.poll.removeSelectedPollOptionIds(widget);
        widget.dataAndAttr('answer-id', notification.object.poll_answer.id);
        real.button.reset(widget.find('.submit-btn'), widget);

        optionsWrapper.addClass('d-none');
        optionsWrapper.find('.poll-option input').prop('checked', false);

        const answerSelections = [];
        notification.object.poll_options.forEach(option => {
            const optionElement = optionsWrapper.find('.poll-option[data-poll-option-id="' + option.id + '"]');
            if (optionElement.length === 0) {
                return;
            }
            optionElement.find('input').prop('checked', true);
            const selectionTemplate = $(howspace.template.getHtml(resultsWrapper.find('.answer-selection-template'), {
                content: optionElement.find('.poll-options-text').text().trim(),
                style: real.escapeHtml(optionElement.data('poll-option-color'))
            }));

            answerSelections.push(selectionTemplate);
        });

        resultsWrapper.find('.answer-selections').html(answerSelections);
        resultsWrapper.find('.answer-selections-wrapper').removeClass('d-none');
        resultsWrapper.find('.change-answer-wrapper').addClass('d-none');
        if (widget.data('can-user-answer') && widget.data('can-user-change-selections') && widget.data('answer-id') !== '') {
            resultsWrapper.find('.change-answer-wrapper').removeClass('d-none');
        }

        // Show the results container
        if (widget.data('show-results')) {
            howspace.animate(resultsWrapper, 'slideDown', 350);
        } else {
            const textWrapper = widget.find('.text-wrapper');
            textWrapper.removeClass('d-none');
            if (widget.data('can-user-answer') && widget.data('can-user-change-selections') && widget.data('answer-id') !== '') {
                textWrapper.find('.change-answer-wrapper').removeClass('d-none');
            }
        }
    };

    howspace.widgets.onEvent('poll:answer:updated', upsertHandler);
    howspace.widgets.onEvent('poll:answer:created', upsertHandler);
    howspace.widgets.onEvent('poll:answer:deleted', (widget, notification) => {
        if (!real.events.isFromCurrentUser(notification)) {
            // New UI backend never sends these to anyone else, but just a sanity check.
            return;
        }

        const deleteBtn = widget.find('.delete-answer-btn');
        const submitBtn = widget.find('.submit-btn');

        howspace.widgets.poll.removeSelectedPollOptionIds(widget);
        widget.removeDataAndAttr('answer-id');

        real.button.reset(deleteBtn, widget);
        deleteBtn.addClass('d-none');

        // Hide results container
        widget.find('.results-wrapper').addClass('d-none');

        widget.find('.options-wrapper .poll-option input').prop('checked', false);
        howspace.animate(widget.find('.options-wrapper'), 'slideDown', 350);

        if (widget.find('.poll-option input:checked').length === 0) {
            submitBtn.prop('disabled', true);
        }

        // Reset these because otherwise "Show results" (admin) would show previous value even when the admin hasn't answered.
        widget.find('.answer-selections').html('');
        widget.find('.change-answer-wrapper, .answer-selections-wrapper').addClass('d-none');
    });

    const getUserAnswerId = widget => widget.data('answer-id');

    const getCurrentSelections = widget => widget.find('.options-wrapper input:checked').map((_idx, input) => $(input).val()).get();

    const isChartOnDisplay = widget => !widget.find('.results-wrapper').hasClass('d-none');

    const drawChart = (widget, options, canvas) => {
        let labels = [], data = [], colors = [];

        for (const key in options.answers) {
            const option = options.answers[key];
            let label = option.label.default;
            if (label.length > 80) {
                label = label.substring(0, 77) + '...';
            }
            labels.push(label);
            data.push(option.answers_count);
            colors.push(option.color);
        }

        const chartType = widget.data('chart-type');

        const chartOptions = {
            type: chartType === 'horizontalBar' ? 'bar' : chartType,
            data: {
                labels: labels,
                datasets: [{
                    backgroundColor: colors,
                    data: data
                }]
            },
            options: {
                responsive: true,
                maintainAspectRatio: true,
                plugins: {
                    legend: { display: false },
                    tooltip: {
                        callbacks: {
                            label: function (context) {
                                const dataset = context.dataset;
                                const label = context.label;
                                const count = dataset.data[context.dataIndex];

                                if (widget.data('show-result-with-percentage')) {
                                    const percentage = count / dataset.data.reduce((a, b) => a + b, 0) * 100;
                                    return `${label}: ${count} (${percentage.toFixed(2)}%)`;
                                } else {
                                    return `${label}: ${count}`;
                                }
                            }
                        }
                    },
                    title: { display: false }
                }
            }
        };

        if (chartType === 'bar') {
            chartOptions.options.scales = {
                x: { display: false, ticks: { autoSkip: false } },
                y: {
                    display: true,
                    ticks: {
                        beginAtZero: true,
                        callback: value => value % 1 === 0 ? value : null
                    }
                }
            };
        } else if (chartType === 'horizontalBar') {
            chartOptions.options.indexAxis = 'y';
            chartOptions.options.scales = {
                x: {
                    display: true,
                    ticks: {
                        beginAtZero: true,
                        callback: value => value % 1 === 0 ? value : null
                    }
                },
                y: { display: false, ticks: { autoSkip: false } }
            };
        }

        if (canvas.length === 0) return;

        if (['pie', 'bar', 'horizontalBar'].includes(chartType)) {
            chartOptions.options.aspectRatio = chartType === 'pie' ? 1.5 : 2;
        }

        const chart = widget.data('chart');
        if (chart) {
            chart.destroy();
        }
        widget.data('chart', new Chart(canvas[0].getContext('2d'), chartOptions));

        if (options.legend) {
            const legend = widget.find('.legend');
            legend.html(options.legend);
            howspace.components.translator.init(legend);
        }
    };

    const updateChartData = (widget, chartPayload) => {
        widget.dataAndAttr('chart-state', chartPayload);
    }

    const renderCurrentChart = (widget) => {
        const chartPayload = widget.data('chart-state');
        if (!chartPayload || !isChartOnDisplay(widget)) {
            return;
        }
        howspace.chart.init(() => {
            drawChart(widget, chartPayload, widget.find('canvas'));
        });
    };

    const initComparisonModal = () => {};

    const initComparisonResultsModal = (modal) => {
        modal = $(modal);
        const widget = $('.widget-poll[data-widget-id="' + modal.data('widget-id') + '"]');
        modal.find('.user-profile-field').each(function () {
            const userProfileField = $(this);
            const answers = userProfileField.data('chart-data');
            if (!answers) {
                return;
            }
            const options = {
                'answers': answers
            }
            const canvas = $(this).find('.poll-chart-canvas');
            howspace.chart.init(() => {
                drawChart(widget, options, canvas);
            });
        });
    };

    const loadResults = function(widget, readyFn) {
        const dataPayload = {
            filter: howspace.widgets.getFilter(widget)
        };

        real.ajax.json(howspace.widgets.getUrl(widget) + '/results', {
            type: 'GET',
            data: dataPayload,
            success: function (response) {
                readyFn(response);
            }
        });
    };

    const showOptions = (widget) => {
        widget.find('.options-wrapper').removeClass('d-none');
        widget.find('.text-wrapper').addClass('d-none');
        widget.find('.results-wrapper').addClass('d-none');
        widget.find('.show-options-btn').prop('disabled', true);
        widget.find('.show-results-btn').prop('disabled', false);
    };

    const showResults = (widget) => {
        widget.find('.options-wrapper').addClass('d-none');
        widget.find('.text-wrapper').addClass('d-none');
        widget.find('.results-wrapper').removeClass('d-none');
        widget.find('.show-options-btn').prop('disabled', false);
        widget.find('.show-results-btn').prop('disabled', true);

        renderCurrentChart(widget);
    };

    howspace.widgets.poll = {
        deleteAnswer: (widget, successFn) => {
            const answerId = getUserAnswerId(widget);
            if (!answerId) {
                return;
            }
            real.ajax.json(howspace.widgets.getApiUrl(widget) + '/pollanswer/' + answerId, {
                type: 'DELETE',
                success: successFn
            });
        },
        submitAnswer: (widget, answers, successFn) => {
            const dataPayload = {
                selected_options: answers,
            };

            const answerId = getUserAnswerId(widget);
            const url = answerId
                      ? `${howspace.widgets.getApiUrl(widget)}/pollanswer/${answerId}`
                      : `${howspace.widgets.getApiUrl(widget)}/pollanswers`;

            real.ajax.json(url, {
                type: 'POST',
                data: JSON.stringify(dataPayload),
                success: successFn,
                logError: response => {
                    return response.status !== 409;
                },
                showErrorNotification: response => {
                    return response.status !== 409;
                },
                error: response => {
                    real.ajax.loopErrors(response, function (error) {
                        if (error.code === 409) {
                            // User has already answered to poll, but UI didn't update fast enough and now
                            // user is trying to answer again and conflict occurred. Just update the
                            // whole widget UI at this point.
                            howspace.widgets.updateWidget(widget, 'view');
                        }
                    });
                }
            });
        },
        setSelectedPollOptionIds: (widget) => {
            real.localStorage.set(widget.prop('id') + '-selected-poll-option-ids', getCurrentSelections(widget));
        },
        removeSelectedPollOptionIds: (widget) => {
            real.localStorage.remove(widget.prop('id') + '-selected-poll-option-ids');
        },
        getSelectedPollOptionIds: (widget) => {
            const pollOptionIds = real.localStorage.get(widget.prop('id') + '-selected-poll-option-ids');
            if (pollOptionIds) {
                widget.find('input').filter(function () {
                    return pollOptionIds.includes($(this).val());
                }).trigger('click');
            }
        },
        initView: widget => {
            const submitBtn = widget.find('.submit-btn');
            const selectOptionsMin = widget.data('select-options-min');
            const selectOptionsMax = widget.data('select-options-max');

            // Show options button.
            widget.find('.show-options-btn').on('click', () => {
                showOptions(widget);
            });

            // Show results button.
            widget.find('.show-results-btn').on('click', () => {
                showResults(widget);
            });

            // Sort results
            widget.find('.sort-results-btn').on('click', e => {
                const btn = $(e.target);

                const dataPayload = {
                    sort_order: btn.data('sort-order')
                };

                real.ajax.json(howspace.widgets.getApiUrl(widget), {
                    type: 'POST',
                    data: JSON.stringify(dataPayload),
                });
            });

            // Save selected options to local storage
            widget.find('input[type=radio]').on('change', () => {
                submitBtn.prop('disabled', false);

                howspace.widgets.poll.setSelectedPollOptionIds(widget);
            });

            widget.find('input[type=checkbox]').on('change', () => {
                const checked = getCurrentSelections(widget).length;
                submitBtn.prop('disabled', checked < selectOptionsMin || checked > selectOptionsMax);

                howspace.widgets.poll.setSelectedPollOptionIds(widget);
            });

            // Submit answer (also used for changing answer)
            submitBtn.on('click', e => {
                const btn = $(e.target);
                real.button.loading(btn, widget);

                const answers = getCurrentSelections(widget);
                howspace.widgets.poll.submitAnswer(widget, answers, () => {
                    howspace.workspace.page.pathMode.handleUserHasInteracted(widget);
                });
            });

            // Remove answer
            widget.find('.delete-answer-btn').on('click', e => {
                const btn = $(e.target);
                real.button.loading(btn, widget);
                howspace.widgets.poll.deleteAnswer(widget, () => {
                    howspace.workspace.page.pathMode.handleUserHasNotInteracted(widget)
                });
            });

            // Change answer
            widget.find('.change-answer-btn').on('click', () => {
                widget.find('.delete-answer-btn').removeClass('d-none');
                showOptions(widget);
            });

            renderCurrentChart(widget);

            howspace.widgets.poll.getSelectedPollOptionIds(widget);
        },
        destroyView: widget => {
            // Destroy the chart (if any).
            const chart = widget.data('chart');
            if (chart) {
                chart.destroy();
            }
        },
        initEdit: widget => {
            widget.find('.add-option-btn').on('click', () => {
                const sortableList = widget.find('.howspace-sortable-list');
                const option = howspace.components.sortableList.addItem(sortableList);
                const index = (sortableList.find('.option').length - 1) % howspace.components.colorPicker.getPalette().length;
                const color = howspace.components.colorPicker.getPalette()[index];
                howspace.components.colorPicker.setColor(option.find('.howspace-color-picker'), color);
            });

            const minOptionsInput = widget.find('input[name="select_options_min"]');
            const maxOptionsInput = widget.find('input[name="select_options_max"]');

            minOptionsInput.on('change', () => {
                const minOptions = parseInt(minOptionsInput.val());
                const maxOptions = parseInt(maxOptionsInput.val());
                if (minOptions > maxOptions) {
                    maxOptionsInput.val(minOptions);
                }
            });

            maxOptionsInput.on('change', () => {
                const minOptions = parseInt(minOptionsInput.val());
                const maxOptions = parseInt(maxOptionsInput.val());
                if (maxOptions < minOptions) {
                    minOptionsInput.val(maxOptions);
                }
            });

            // Add first option.
            if (widget.find('.option').length === 0) {
                widget.find('.add-option-btn').trigger('click');
            }
        },
        destroyEdit: widget => {
            // Empty for now.
        },
        save: (widget, dataPayload) => {
            dataPayload.poll_options = [];
            widget.find('.option:not(.deleted)').each(function () {
                dataPayload.poll_options.push(real.form.getDataPayload($(this)));
            });

            // Adjust the min and max options into a valid range.
            const minOptionsInput = widget.find('input[name="select_options_min"]');
            const maxOptionsInput = widget.find('input[name="select_options_max"]');

            let minOptions = parseInt(minOptionsInput.val());
            let maxOptions = parseInt(maxOptionsInput.val());
            const optionsCount = dataPayload.poll_options.length;

            if (!minOptions || minOptions < 1) {
                minOptions = 1;
            } else if(minOptions > optionsCount) {
                minOptions = optionsCount;
            }

            if (!maxOptions || maxOptions < 1) {
                maxOptions = 1;
            } else if(maxOptions > optionsCount) {
                maxOptions = optionsCount;
            }

            if (minOptions > maxOptions) {
                maxOptions = minOptions;
            }

            dataPayload['select_options_min'] = minOptions;
            dataPayload['select_options_max'] = maxOptions;

            return dataPayload;
        },
        initComparisonModal: initComparisonModal,
        initComparisonResultsModal: initComparisonResultsModal,
        updateFilter : (widget) => {
            loadResults(widget, (results) => {
                updateChartData(widget, results);
                showResults(widget);
            });
        }
    }
})();
